import { useState, useEffect } from "react";
import { Modal, Form, Input, Select, InputNumber, Button } from "antd";

const { Option } = Select;

const AddVehicleModal = ({ open, onCancel, onSave, initialValues }) => {
  const [form] = Form.useForm();

  const [isDirty, setIsDirty] = useState(false);
  const [baseline, setBaseline] = useState(null);

  useEffect(() => {
    if (open) {
      const values = initialValues || {
        vehicle_model: "",
        vehicle_type: "University Owned",
        plate_number: "",
        max_passenger_capacity: 4,
      };
      form.setFieldsValue(values);
      setBaseline(values);
      setIsDirty(false);
    }
  }, [open, initialValues, form]);

  const handleValuesChange = (_, allValues) => {
    if (!initialValues) {
      setIsDirty(true);
      return;
    }
    
    let dirty = false;
    if (allValues.vehicle_model !== baseline?.vehicle_model) dirty = true;
    else if (allValues.vehicle_type !== baseline?.vehicle_type) dirty = true;
    else if (allValues.plate_number !== baseline?.plate_number) dirty = true;
    else if (allValues.max_passenger_capacity !== baseline?.max_passenger_capacity) dirty = true;
    
    setIsDirty(dirty);
  };

  const sanitizeInput = (val) => {
    if (typeof val !== 'string') return val;
    return val.trim().replace(/\s+/g, ' ');
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        const sanitized = {
          ...values,
          vehicle_model: sanitizeInput(values.vehicle_model),
          plate_number: sanitizeInput(values.plate_number)
        };
        onSave(sanitized); // Pass data back to the parent page
        form.resetFields();
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  return (
    <Modal
      open={open}
      title={initialValues ? "Edit Vehicle" : "Add New Vehicle"}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button 
          key="save" 
          type="primary" 
          className="ouber-btn-primary" 
          onClick={handleSubmit}
          style={{ marginBottom: 0 }}
          disabled={initialValues && !isDirty}
        >
          {initialValues ? "Save Changes" : "Add Vehicle"}
        </Button>
      ]}
      className="ouber-modal"
      width={600}
    >
      <Form 
        form={form} 
        layout="vertical" 
        name="vehicle_form"
        style={{ marginTop: '20px' }}
        onValuesChange={handleValuesChange}
      >
        <Form.Item
          name="vehicle_model"
          label="Vehicle Model"
          rules={[
            { required: true, message: "Please input the vehicle model!" },
          ]}
        >
          <Input placeholder="e.g. Toyota Innova" />
        </Form.Item>

        <Form.Item
          name="vehicle_type"
          label="Vehicle Type"
          rules={[{ required: true }]}
        >
          <Select>
            <Option value="University Owned">University Owned</Option>
            <Option value="Car Rental">Car Rental</Option>
            <Option value="Carpool">Carpool</Option>
            <Option value="Outsourced">Outsourced</Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="plate_number"
          label="Plate Number"
          rules={[
            { required: true, message: "Please input the plate number!" },
          ]}
        >
          <Input placeholder="e.g. ABC 1234" />
        </Form.Item>

        <Form.Item
          name="max_passenger_capacity"
          label="Capacity"
          rules={[{ required: true }]}
        >
          <InputNumber min={1} max={50} style={{ width: "100%" }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddVehicleModal;
